import { useLocalStorage } from '@vueuse/core';
import type { Route } from 'vue-router';
import {
  isAssistantEnabled,
  isAssistantOverride,
  TAssistantOverride,
} from '@/domain/assistant/assistant-rollout';

/**
 * «Asistente» rollout (plan §9.1): the rule of `assistant-rollout.ts` plus a
 * per-device override set with `?assistant=on|off|default` on any route (the
 * pattern of `use-menu-v2.ts`).
 */
const override = useLocalStorage<TAssistantOverride>(
  'assistantOverride',
  'default'
);

function currentOverride(): TAssistantOverride {
  return isAssistantOverride(override.value) ? override.value : 'default';
}

/** Whether the panel replaces the GPTHelp bubble in the store `stringId` (reactive to the override). */
export function assistantEnabledFor(
  stringId: string | null,
  isStaff: boolean
): boolean {
  return isAssistantEnabled({ override: currentOverride(), isStaff, stringId });
}

type TQuery = Route['query'];

/**
 * Stores an `?assistant=` override and returns the query without it;
 * `stripped` tells the global guard to redirect to the clean URL.
 */
export function applyAssistantQueryOverride(
  query: TQuery
): {
  query: TQuery;
  stripped: boolean;
} {
  if (!('assistant' in query)) return { query, stripped: false };
  const value = query.assistant;
  if (isAssistantOverride(value)) override.value = value;
  const rest = { ...query };
  delete rest.assistant;
  return { query: rest, stripped: true };
}
